<template>
    <form class="action-form" :action="`/referrals/${referral.id}/cancel`" @submit.prevent="submit()">
        <button class="action-btn" type="submit" :disabled="form.isSubmitted">
            <span v-if="form.isSubmitted">Canceling</span>
            <span v-else>Cancel</span>
        </button>
    </form>
</template>
<script>

import Toast from "@/classes/Toast";
import Form from "@/classes/Form";

export default {

    props:['referral'],

    data(){
        return {
            form: new Form(),
        }
    },

    methods:{
        submit(){
           this.form.delete(`/referrals/${this.referral.id}`)
                .then(response => {
                    eventBus.$emit('update-referrals', response.referrals)
                    Toast.success('Referral Cancelled')
                });
        }
    }
}
</script>
